// extracted by mini-css-extract-plugin
export default {"cardImage":"ColorCardSkeleton_cardImage__Ks7Id","cardTitle":"ColorCardSkeleton_cardTitle__KxRnU","cardBtn":"ColorCardSkeleton_cardBtn__yMecY"};